import { Observable, Subject } from 'rxjs';

export abstract class Dialog {
  private _closed: Subject<void> = new Subject();

  public get closed(): Observable<void> {
    return this._closed.asObservable();
  }

  public close(): void {
    this._closed.next();
    this._closed.complete();
  }
}
